import React from 'react';
import { Row, Col } from 'antd';
import Header from './components/Header/index'
import Footer from './components/Footer/index'
import NavLeft from './components/NavLeft/index'
// import Home from './pages/home/index'
import './style/common.less'
import ListArt from './pages/listart';

export default class Home extends React.Component {
    render() {
        return (
            <div className='body'>
                <Row><Header></Header></Row>
                <Row className='container'>
                    <Col span={3} className='nav-left'>
                        <NavLeft></NavLeft>
                    </Col>
                    <Col span={21} className='main'>

                        <Row className='content'>
                            {/* <Home></Home> */}
                            {/* <ListArt></ListArt> */}
                            {this.props.children}
                        </Row>
                    </Col>
                </Row>
                <Row className="footer"><Footer></Footer></Row>
            </div>
        );
    }
}
